import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ui-page-loader',
  templateUrl: './ui-page-loader.component.html',
  styleUrls: ['./ui-page-loader.component.scss'],
  standalone: false,
})
export class UiPageLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
